"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeBlock = void 0;
var slate_1 = require("slate");
var EditorTypes_1 = require("../EditorTypes");
var Table_1 = require("ContentTokens/DataModels/Table");
var SideBySide_1 = require("ContentTokens/DataModels/SideBySide");
var ContentLoop_1 = require("ContentTokens/DataModels/ContentLoop");
var SchemaType_1 = require("./SchemaType");
var TokenModels_1 = __importDefault(require("ContentTokens/TokenModels"));
var SideBySide_2 = require("ContentTokens/Models/SideBySide");
var NormalizeVoidNode_1 = require("./NormalizeVoidNode");
var Accordion_1 = require("ContentTokens/DataModels/Accordion");
var Utils_1 = require("../Utils");
var lodash_1 = require("lodash");
var EditorWidgetRegistry_1 = require("Project/QwilrEditor/WidgetRegistry/EditorWidgetRegistry");
var normalizeBlock = function (_a, editor, schema) {
    var _b;
    var _c = __read(_a, 2), node = _c[0], path = _c[1];
    var editorRegistryNormalizerResult = (_b = (0, EditorWidgetRegistry_1.getGenericConfigByType)(node.type)) === null || _b === void 0 ? void 0 : _b.normalizeWidget(node, path, editor);
    if (!(0, lodash_1.isUndefined)(editorRegistryNormalizerResult)) {
        return editorRegistryNormalizerResult;
    }
    if (schema.blocks[node.type] == undefined) {
        return false;
    }
    switch (node.type) {
        case EditorTypes_1.BlockType.Paragraph:
        case EditorTypes_1.BlockType.Heading1:
        case EditorTypes_1.BlockType.Heading2:
        case EditorTypes_1.BlockType.BlockQuote:
        case EditorTypes_1.BlockType.SideBySideDummy:
        case EditorTypes_1.BlockType.AccordionDummy:
        case EditorTypes_1.BlockType.TableDummy:
        case EditorTypes_1.BlockType.ContentLoopBody:
        case EditorTypes_1.BlockType.ContentLoopDummy:
        case EditorTypes_1.BlockType.HorizontalRule:
        case EditorTypes_1.BlockType.SideBySideColumn:
        case EditorTypes_1.BlockType.TableCell:
        case EditorTypes_1.BlockType.ROICalculator:
            return normalizeBasicBlock(node, path, editor, schema);
        case EditorTypes_1.BlockType.AccordionBody:
            return normalizeAccordionBody(node, path, editor, schema);
        case EditorTypes_1.BlockType.AccordionHeading:
            return normalizeAccordionHeading(node, path, editor, schema);
        case EditorTypes_1.BlockType.Accordion:
            return normalizeAccordion(node, path, editor, schema);
        case EditorTypes_1.BlockType.ListItem:
            return normalizeBasicBlock(node, path, editor, schema) || normalizeListItemData(node, path, editor);
        case EditorTypes_1.BlockType.Button:
            return normalizeBasicBlock(node, path, editor, schema) || normalizeButtonData(node, path, editor);
        case EditorTypes_1.BlockType.Image:
            return (normalizeBasicBlock(node, path, editor, schema) ||
                normalizeImageData(node, path, editor) ||
                normalizeWideWidget(node, path, editor));
        case EditorTypes_1.BlockType.Table:
            return normalizeTable(node, path, editor);
        case EditorTypes_1.BlockType.TableRow:
        case EditorTypes_1.BlockType.TableRepeatingRow:
            return normalizeTableRow(node, path, editor, schema);
        case EditorTypes_1.BlockType.SideBySide:
            return normalizeSideBySide(node, path, editor);
        case EditorTypes_1.BlockType.ContentLoop:
            return normalizeContentLoop(node, path, editor);
        case EditorTypes_1.BlockType.GoogleMaps:
        case EditorTypes_1.BlockType.Video:
        case EditorTypes_1.BlockType.Iframe:
            return normalizeBasicBlock(node, path, editor, schema) || normalizeWideWidget(node, path, editor);
    }
    return false;
};
exports.normalizeBlock = normalizeBlock;
var normalizeBasicBlock = function (node, path, editor, schema) {
    var blockConfig = schema.blocks[node.type];
    if (!blockConfig) {
        return false;
    }
    if (blockConfig.isVoid) {
        return (0, NormalizeVoidNode_1.normalizeVoidNode)(node, path, editor);
    }
    else {
        return normalizeBlockChildren(node, path, editor, schema);
    }
};
var normalizeBlockChildren = function (node, path, editor, schema) {
    var _a;
    var blockSchema = schema.blocks[node.type];
    var validChildren = blockSchema.validChildren;
    for (var i = 0; i < node.children.length; i++) {
        var currChild = node.children[i];
        if (!validChildren.includes(currChild.type) &&
            !((_a = (0, EditorWidgetRegistry_1.getGenericConfigByType)(currChild.type)) === null || _a === void 0 ? void 0 : _a.validContainers.includes(node.type)) &&
            !slate_1.Text.isText(currChild)) {
            slate_1.Transforms.unwrapNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false), voids: true });
            return true;
        }
        if ((0, SchemaType_1.isContainerBlockSchema)(blockSchema) && slate_1.Text.isText(currChild)) {
            slate_1.Transforms.delete(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false) });
            return true;
        }
    }
    if (node.children.length < 1) {
        var createTextNode = function () { return TokenModels_1.default.text.createSlateJson(""); };
        var createDefaultChildNode = (0, SchemaType_1.isContainerBlockSchema)(blockSchema)
            ? blockSchema.createDefaultChildNode
            : createTextNode;
        var defaultChild = createDefaultChildNode();
        slate_1.Transforms.insertNodes(editor, defaultChild, { at: __spreadArray(__spreadArray([], __read(path), false), [0], false) });
        return true;
    }
    return false;
};
var normalizeListItemData = function (node, path, editor) {
    var data = node.data;
    var level = data.level;
    var listType = data.listType;
    var startCounter = data.startCounter;
    var shouldNormalize = false;
    if (level == undefined || level < 1) {
        shouldNormalize = true;
        level = 1;
    }
    if (listType !== EditorTypes_1.ListType.Bullet && listType !== EditorTypes_1.ListType.Number) {
        shouldNormalize = true;
        listType = EditorTypes_1.ListType.Bullet;
    }
    if (shouldNormalize) {
        var normalizedData = {
            level: level,
            listType: listType,
        };
        if (startCounter != undefined) {
            normalizedData.startCounter = startCounter;
        }
        slate_1.Transforms.setNodes(editor, { data: normalizedData }, { at: path });
        return true;
    }
    else {
        return false;
    }
};
var normalizeImageData = function (node, path, editor) {
    if (node.data.src == undefined) {
        var updatedData = __assign(__assign({}, node.data), { src: "" });
        slate_1.Transforms.setNodes(editor, { data: updatedData }, { at: path });
        return true;
    }
    else {
        return false;
    }
};
var normalizeButtonData = function (node, path, editor) {
    if (node.data.text == undefined) {
        node.data.text = "";
        slate_1.Transforms.setNodes(editor, { data: node.data }, { at: path });
        return true;
    }
    else {
        return false;
    }
};
var normalizeTable = function (node, path, editor) {
    if (!node.children.length || node.children[0].type !== EditorTypes_1.BlockType.TableDummy) {
        var newDummy = (0, Table_1.createTableDummyNode)();
        slate_1.Transforms.insertNodes(editor, newDummy, { at: __spreadArray(__spreadArray([], __read(path), false), [0], false) });
        return true;
    }
    for (var i = 1; i < node.children.length; i++) {
        if (node.children[i].type !== EditorTypes_1.BlockType.TableRow && node.children[i].type !== EditorTypes_1.BlockType.TableRepeatingRow) {
            slate_1.Transforms.removeNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false) });
            return true;
        }
    }
    if (node.children.length === 1) {
        slate_1.Transforms.insertNodes(editor, (0, Table_1.createEmptyTableRowNode)(), { at: __spreadArray(__spreadArray([], __read(path), false), [1], false) });
        return true;
    }
    return false;
};
var normalizeSideBySide = function (node, path, editor) {
    if (!node.children.length || node.children[0].type !== EditorTypes_1.BlockType.SideBySideDummy) {
        var newDummy = (0, SideBySide_1.createSideBySideDummy)();
        slate_1.Transforms.insertNodes(editor, newDummy, { at: __spreadArray(__spreadArray([], __read(path), false), [0], false) });
        return true;
    }
    if (node.children.length === SideBySide_2.SIDE_BY_SIDE_NUM_CHILDREN) {
        if (node.children[1].type !== EditorTypes_1.BlockType.SideBySideColumn) {
            replaceChildWithSideBySideColAtIndex(editor, path, 1);
            return true;
        }
        if (node.children[2].type !== EditorTypes_1.BlockType.SideBySideColumn) {
            replaceChildWithSideBySideColAtIndex(editor, path, 2);
            return true;
        }
    }
    if (node.children.length < SideBySide_2.SIDE_BY_SIDE_NUM_CHILDREN) {
        slate_1.Transforms.insertNodes(editor, (0, SideBySide_1.blankSlateColumn)(), { at: __spreadArray(__spreadArray([], __read(path), false), [2], false) });
        return true;
    }
    if (node.children.length > SideBySide_2.SIDE_BY_SIDE_NUM_CHILDREN) {
        slate_1.Transforms.removeNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [3], false) });
        return true;
    }
    return false;
};
var normalizeContentLoop = function (node, path, editor) {
    if (!node.children.length || node.children[0].type !== EditorTypes_1.BlockType.ContentLoopDummy) {
        slate_1.Transforms.insertNodes(editor, (0, ContentLoop_1.createContentLoopDummy)(), { at: __spreadArray(__spreadArray([], __read(path), false), [0], false) });
        return true;
    }
    if (!node.children[1] || node.children[1].type !== EditorTypes_1.BlockType.ContentLoopBody) {
        slate_1.Transforms.insertNodes(editor, (0, ContentLoop_1.createContentLoopBody)(), { at: __spreadArray(__spreadArray([], __read(path), false), [1], false) });
        return true;
    }
    if (node.children.length > 2) {
        slate_1.Transforms.removeNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [2], false) });
        return true;
    }
    return false;
};
var replaceChildWithSideBySideColAtIndex = function (editor, path, index) {
    slate_1.Editor.withoutNormalizing(editor, function () {
        slate_1.Transforms.removeNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [index], false) });
        slate_1.Transforms.insertNodes(editor, (0, SideBySide_1.blankSlateColumn)(), { at: __spreadArray(__spreadArray([], __read(path), false), [index], false) });
    });
};
var normalizeAccordion = function (node, path, editor, schema) {
    var hasBeenEviscerated = !node.children.length || node.children.length <= 1;
    if (hasBeenEviscerated) {
        if (!node.children.length || node.children[0].type === EditorTypes_1.BlockType.AccordionDummy) {
            slate_1.Transforms.removeNodes(editor, { at: path });
            return true;
        }
        slate_1.Editor.withoutNormalizing(editor, function () {
            slate_1.Transforms.unwrapNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [0], false) });
            slate_1.Transforms.unwrapNodes(editor, { at: path });
        });
        return true;
    }
    if (!node.children.length || node.children[0].type !== EditorTypes_1.BlockType.AccordionDummy) {
        slate_1.Transforms.insertNodes(editor, (0, Accordion_1.accordionDummy)(), { at: __spreadArray(__spreadArray([], __read(path), false), [0], false) });
        return true;
    }
    if (!node.children[1] || node.children[1].type !== EditorTypes_1.BlockType.AccordionHeading) {
        slate_1.Transforms.insertNodes(editor, (0, Accordion_1.blankAccordionHeading)(), { at: __spreadArray(__spreadArray([], __read(path), false), [1], false) });
        return true;
    }
    if (!node.children[2] || node.children[2].type !== EditorTypes_1.BlockType.AccordionBody) {
        slate_1.Transforms.insertNodes(editor, (0, Accordion_1.blankAccordionBody)(), { at: __spreadArray(__spreadArray([], __read(path), false), [2], false) });
        return true;
    }
    if (node.children.length > 3) {
        slate_1.Transforms.removeNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [3], false) });
        return true;
    }
    if (normalizeAccordionHeading(node.children[1], __spreadArray(__spreadArray([], __read(path), false), [1], false), editor, schema)) {
        return true;
    }
    if (normalizeAccordionBody(node.children[2], __spreadArray(__spreadArray([], __read(path), false), [2], false), editor, schema)) {
        return true;
    }
    return false;
};
var normalizeAccordionBody = function (node, path, editor, schema) {
    return normalizeBasicBlock(node, path, editor, schema);
};
var normalizeAccordionHeading = function (node, path, editor, schema) {
    if (node.children && node.children.length > 1) {
        var _a = __read((0, Utils_1.getNext)(editor, path, function (curr) {
            return curr.type === EditorTypes_1.BlockType.AccordionBody;
        }), 2), accordionBody = _a[0], accordionBodyPath = _a[1];
        if (slate_1.Editor.isEmpty(editor, node.children[1])) {
            slate_1.Transforms.removeNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [1], false) });
            (0, Utils_1.moveToStartOfNextText)(editor);
        }
        else {
            slate_1.Transforms.moveNodes(editor, {
                at: __spreadArray(__spreadArray([], __read(path), false), [node.children.length - 1], false),
                to: __spreadArray(__spreadArray([], __read(accordionBodyPath), false), [0], false),
            });
        }
        return true;
    }
    return normalizeBasicBlock(node, path, editor, schema);
};
function normalizeTableRow(node, path, editor, schema) {
    var table = (0, Utils_1.checkAncestors)(editor, path, function (c) { return c.type === EditorTypes_1.BlockType.Table; });
    if (table) {
        if (node.children.length < table[0].data.columns) {
            slate_1.Transforms.insertNodes(editor, (0, Table_1.createEmptyTableCellNode)(), { at: __spreadArray(__spreadArray([], __read(path), false), [node.children.length], false) });
            return true;
        }
    }
    return normalizeBasicBlock(node, path, editor, schema);
}
var normalizeWideWidget = function (node, path, editor) {
    if (typeof node.data.width === "string") {
        var parentEntry = slate_1.Editor.parent(editor, path);
        var _a = __read(parentEntry, 1), parentNode = _a[0];
        if (!slate_1.Editor.isEditor(parentEntry[0]) && parentNode.type !== EditorTypes_1.BlockType.ContentLoopBody) {
            var nextData = (0, lodash_1.cloneDeep)(node.data);
            nextData.width = 100;
            slate_1.Transforms.setNodes(editor, { data: nextData }, { at: path });
            return true;
        }
    }
};
